import styled from 'styled-components';
import { colors, typography } from '../../lib/styles';

const DisplayName = styled.span`
    color: ${colors.typography.displayName};
    font-family: ${typography.fontFamilies.attribution};
    font-style: italic;
`;

export default DisplayName;
